/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import SelectDropdown, { type ISelectDropdownAttrs } from 'flarum/common/components/SelectDropdown';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';

export interface BookshelfDropdownAttrs extends ISelectDropdownAttrs {
	// Optional in `Dropdown`, but always defaulted by `Dropdown.initAttrs()`.
	buttonClassName: string;
	caretIcon: string;
	onclick?: (event: MouseEvent) => void;
	disabled?: boolean;
	loading?: boolean;
}

export default class BookshelfDropdown<CustomAttrs extends BookshelfDropdownAttrs = BookshelfDropdownAttrs> extends SelectDropdown<CustomAttrs> {
	oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
		super.oncreate(vnode);

		this.$('.Dropdown-menu').on('click', (e) => {
			const shouldHide = (e.target as HTMLElement).className.indexOf('Button--primary') != -1;
			if (!shouldHide) {
				e.stopPropagation();
			}
		});
	}

	getButton(): Mithril.Vnode<any, any> {
		const { buttonClassName, onclick, disabled } = this.attrs;

		return (
			<button className={'Dropdown-toggle ' + buttonClassName} data-toggle="dropdown" onclick={onclick} disabled={disabled}>
				{this.getButtonContent()}
			</button>
		);
	}

	getButtonContent(): Mithril.ChildArray {
		const { label, caretIcon, loading } = this.attrs;

		return [
			<span className="Button-label">{label}</span>,

			loading ? <LoadingIndicator size="small" display="inline" /> : icon(caretIcon, { className: 'Button-caret' }),
		];
	}
}
